// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c86ee63dcde26f5542fd","9503":"e5eefca1b3526bc66b36"}[chunkId] + ".css";
};